<div class="container p-2">
  <div class="mat-dialog-content">
    <p>Are you sure you want to complete this trip?</p>
  </div>

  <div class="flex_container" mat-dialog-actions>
    <button class="ex2" mat-button mat-dialog-close (click)="cancel()">
      Cancel
    </button>
    <button class="ex1" mat-button [disabled]="loading" (click)="cancelTrip()">
      {{ loading ? 'Completing...' : 'OK' }}
    </button>
  </div>
</div>
